import { Injectable } from '@angular/core';
import * as tz from 'moment-timezone';
var moment = require('moment');
import * as _ from "lodash";
import { LoopBackFilter, App } from '../sdk/models/';
import { AppApi } from '../sdk/services/custom';
import { getFieldFromArray, isNotEmpty, valueLabel } from '../utils/util';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class PlatformApp {
    static appvariables: any = {};

    static app: any;

    constructor() {
    }

    static setApp(app) {
        this.app = app;
    }

    static getApp() {
        return this.app;
    }

    static removeApp() {
        delete this.app;
    }

    static setAppVariable(key, value) {
        this.appvariables[key] = value;
    }

    static getAppVariable(key) {
        return this.appvariables[key];
    }

    static getNotificationOptions(id?) {
        return {
            id: id,
            timeOut: 1000,
            lastOnBottom: true,
            clickToClose: true,
            maxLength: 0,
            maxStack: 5,
            showProgressBar: true,
            preventDuplicates: true,
            pauseOnHover: false,
            rtl: false,
            animate: 'scale',
            position: ['right', 'bottom']
        };
    }

    static findAndReplace(object, findkey, findvalue, replacekey, replacevalue) {
        if (typeof object[x] == typeof {} || typeof object == typeof [])
            for (var x in object)
                if (typeof object[x] == typeof {} || typeof object == typeof [])
                    this.findAndReplace(object[x], findkey, findvalue, replacekey, replacevalue);
                else if (x == findkey && object[x] == findvalue)
                    object[replacekey] = replacevalue;
        return object;
    }

    static validateValue(value, checker, operation) {
        switch (operation) {
            case '<=':
                if (Number(value) <= Number(checker))
                    return true;
                break;
            case '<':
                if (Number(value) < Number(checker))
                    return true;
                break;
            case '==':
                if (value == checker)
                    return true;
                break;
            case '>=':
                if (Number(value) >= Number(checker))
                    return true;
                break;
            case '>':
                if (Number(value) > Number(checker))
                    return true;
                break;
            case '!==':
                if (value !== checker)
                    return true;
                break;
            default:
                break;
        }
        return false;
    }

    static processData(functionCall, dataArray) {

        var formatYYYYMMDD = 'YYYY-MM-DD';
        var formatDDMMYYYY = 'DD/MM/YYYY';
        var formatDDMM = 'DD/MM';
        var delimiterHyphen = '-';
        var delimiterSlash = '/';
        var delimiterColon = ':';
        var delimiterDot = '.';
        var roundOff = 2;

        switch (functionCall) {

            case 'COPY':
                return dataArray[0];

            case 'AMTCOPY':
                return parseFloat(dataArray[0]);

            case 'CONCATENATE':
                var valueStr = '';
                dataArray.forEach(function (str) {
                    valueStr = valueStr + " " + str;
                });
                return valueStr;

            case 'MERGE':
                var valueStr = '';
                dataArray.forEach(function (str) {
                    valueStr = valueStr + str;
                });
                return valueStr;

            case 'ADD':
                var valueNum = 0;
                dataArray.forEach(function (numStr) {
                    valueNum = valueNum + parseFloat(numStr);
                });
                return valueNum.toString();

            case 'SUB':
                var valueNum = parseFloat(dataArray[0]);
                for (var i = 1; i < dataArray.length; i++) {
                    valueNum = valueNum - parseFloat(dataArray[i]);
                }
                return valueNum.toString();

            case 'ADDSUB':
                var valueNum = parseFloat(dataArray[0]) + parseFloat(dataArray[1]) - parseFloat(dataArray[2]);
                return valueNum.toString();

            case 'DURATION':
                var duration = [];
                var days = 0;
                if (dataArray[1] == "years") {
                    days = parseInt(dataArray[0]) * 365;
                } else {
                    if (dataArray[1] == "months") {
                        days = parseInt(dataArray[0]) * 30;
                    } else {
                        days = parseInt(dataArray[0]);
                    }
                }
                duration.push(days);

                var months = 0;
                if (dataArray[1] == "years") {
                    months = parseInt(dataArray[0]) * 12;
                } else {
                    if (dataArray[1] == "months") {
                        months = parseInt(dataArray[0]);
                    } else {
                        months = parseInt(dataArray[0]) / 30;
                    }
                }
                duration.push(months);

                var years = 0;
                if (dataArray[1] == "years") {
                    years = parseInt(dataArray[0]);
                } else {
                    if (dataArray[1] == "months") {
                        years = parseInt(dataArray[0]) / 12;
                    } else {
                        years = parseInt(dataArray[0]) / 365;
                    }
                }
                duration.push(years);
                return JSON.stringify(duration);

            case 'TODAY':
                return moment().format(formatYYYYMMDD);

            case 'ADDDAYS':
                return this.stringToDate(dataArray[0], formatYYYYMMDD, delimiterHyphen).add(parseInt(dataArray[1]), 'days').format(formatYYYYMMDD);

            case 'ADDMONTHS':
                return this.stringToDate(dataArray[0], formatYYYYMMDD, delimiterHyphen).add(parseInt(dataArray[1]), 'months').format(formatYYYYMMDD);

            case 'ADDYEARS':
                return this.stringToDate(dataArray[0], formatYYYYMMDD, delimiterHyphen).add(parseInt(dataArray[1]), 'years').format(formatYYYYMMDD);

            case 'ADDDAYSDUR':
                return this.stringToDate(dataArray[0], formatYYYYMMDD, delimiterHyphen).add(parseInt(dataArray[1]), dataArray[2]).format(formatYYYYMMDD);

            case 'DATESDDMM':
                var startDate = this.stringToDate(dataArray[0], formatYYYYMMDD, delimiterHyphen);
                var monthsToAdd = Math.round(12 / parseInt(dataArray[1]));

                var dates = [];
                for (var freq = 1; freq < parseInt(dataArray[1]) + 1; freq++) {
                    dates.push(startDate.add(monthsToAdd, 'months').format(formatDDMM));
                }
                return JSON.stringify(dates);

            case 'MULTIPLY':
                var valueNum = 1;
                dataArray.forEach(function (numStr) {
                    valueNum = valueNum * parseFloat(numStr);
                });
                return valueNum;

            case 'DIVIDE':
                var valueNum = parseFloat(dataArray[0]) / parseFloat(dataArray[1]);
                return valueNum;

            case 'CREDIT':
                if (dataArray[0] == 'credit') {
                    return '+' + parseFloat(dataArray[1]);
                } else {
                    return '0';
                }

            case 'CREDITDEBIT':
                if (dataArray[0] == 'credit') {
                    return '+' + parseFloat(dataArray[1]);
                } else {
                    return '-' + parseFloat(dataArray[1]);
                }

            case 'DEBIT':
                if (dataArray[0] == 'debit') {
                    return '-' + parseFloat(dataArray[1]);
                } else {
                    return '0';
                }

            case 'AMTADD':
                var valueNum = 0;
                dataArray.forEach(function (numStr) {
                    valueNum = valueNum + parseFloat(numStr);
                });
                return valueNum;

            case 'AMTSUB':
                var valueNum = parseFloat(dataArray[0]);
                for (var i = 1; i < dataArray.length; i++) {
                    valueNum = valueNum - parseFloat(dataArray[i]);
                }
                return valueNum;

            case 'AMTADDSUB':
                var valueNum = parseFloat(dataArray[0]) + parseFloat(dataArray[1]) - parseFloat(dataArray[2]);
                return valueNum;

            case 'AMTMUL':
                var valueNum = 1;
                dataArray.forEach(function (numStr) {
                    valueNum = valueNum * parseFloat(numStr);
                });
                return valueNum;

            case 'AMTDIV':
                var valueNum = parseFloat(dataArray[0]) / parseFloat(dataArray[1]);
                return valueNum;

            case 'AMTSUBDIV':
                var valueNum = (parseFloat(dataArray[0]) - parseFloat(dataArray[1])) / parseFloat(dataArray[2]);
                return valueNum;

            case 'AMTADDDIV':
                var valueNum = (parseFloat(dataArray[0]) + parseFloat(dataArray[1])) / parseFloat(dataArray[2]);
                return valueNum;

            case 'AMTSUBDIVPERC':
                var valueNum = ((parseFloat(dataArray[0]) - parseFloat(dataArray[1])) * 100) / parseFloat(dataArray[2]);
                return valueNum;

            case 'AMTADDDIVPERC':
                var valueNum = ((parseFloat(dataArray[0]) + parseFloat(dataArray[1])) * 100) / parseFloat(dataArray[2]);
                return valueNum;

            case 'AMTDIVDAYS':
                var valueNum = parseFloat(dataArray[0]) / parseFloat(JSON.parse(dataArray[1])[0]);
                return valueNum;

            case 'AMTDIVMONTHS':
                var valueNum = parseFloat(dataArray[0]) / parseFloat(JSON.parse(dataArray[1])[1]);
                return valueNum;;

            case 'AMTDIVYEARS':
                var valueNum = parseFloat(dataArray[0]) / parseFloat(JSON.parse(dataArray[1])[2]);
                return valueNum;

            case 'AMTMULPERC':
                var valueNum = (parseFloat(dataArray[0]) * parseFloat(dataArray[1])) / 100;
                return valueNum;

            case 'AMTDIVPERC':
                var valueNum = (parseFloat(dataArray[0]) * 100) / parseFloat(dataArray[1]);
                return valueNum;

            case 'AMTMULPERCMULDAYS':
                var valueNum = (parseFloat(dataArray[0]) * parseFloat(dataArray[1]) * parseFloat(dataArray[2])) / (365 * 100);
                return valueNum;

            case 'AMTMULPERCMULDAYSDUR':
                var valueNum = 0;

                if (dataArray[3] == "years") {
                    valueNum = (parseFloat(dataArray[0]) * parseFloat(dataArray[1]) * parseFloat(dataArray[2])) / 100;
                } else {
                    if (dataArray[3] == "months") {
                        valueNum = (parseFloat(dataArray[0]) * parseFloat(dataArray[1]) * parseFloat(dataArray[2]) * 30) / (365 * 100);
                    } else {
                        valueNum = (parseFloat(dataArray[0]) * parseFloat(dataArray[1]) * parseFloat(dataArray[2])) / (365 * 100);
                    }
                }
                return valueNum;

            case 'AMTDIVDAYSDUR':
                var valueNum = 0;

                if (dataArray[2] == "years") {
                    valueNum = parseFloat(dataArray[0]) / parseFloat(dataArray[1]);
                } else {
                    if (dataArray[2] == "months") {
                        valueNum = (parseFloat(dataArray[0]) / (parseFloat(dataArray[1]) / 12));
                    } else {
                        valueNum = (parseFloat(dataArray[0]) / (parseFloat(dataArray[1]) / 365));
                    }
                }
                return valueNum;

            case 'YIELD':
                valueNum = 0;
                valueNum = ((100 - parseFloat(dataArray[0])) * 100) / parseFloat(dataArray[0]);
                return valueNum;

            case 'YIELDPERC':
                valueNum = 0;
                valueNum = ((parseFloat(dataArray[1]) - parseFloat(dataArray[0])) * 100) / parseFloat(dataArray[0]);
                return valueNum;

            default:
                console.log("Error in Function Call : " + functionCall);
        }
        return null;
    }

    static stringToDate(_date, _format?, _delimiter?) {

        if (!_format || !_delimiter) {
            switch (true) {
                case /^\d{4}(-|\/)\d{0,2}(-|\/)\d{0,2}$/g.test(_date):
                    _format = 'YYYY-MM-DD';
                    _delimiter = '-'
                    break;

                case /^\d{0,2}(-|\/)\d{0,2}(-|\/)\d{4}$/g.test(_date):
                    _format = 'DD/MM/YYYY';
                    _delimiter = '/'
                    break;

                default:
                    return null;
            }
        }

        if (_date) {
            var formatLowerCase = _format.toLowerCase();
            var formatItems = formatLowerCase.split(_delimiter);
            var dateItems = _date.split(_delimiter);

            var yearIndex = formatItems.indexOf("yyyy");
            var monthIndex = formatItems.indexOf("mm");
            var dayIndex = formatItems.indexOf("dd");
            var month = Number(dateItems[monthIndex]) - 1;

            var date = moment([dateItems[yearIndex], month, dateItems[dayIndex]]);
            //This is a hack to handle TIM timezone
            date = date.endOf('day');
            return date;
        } else
            return null;
    }

    static getDateVariableValues(dateVariable, condition) {

        if (condition == 'between') {
            return {
                between: [moment(_.split(dateVariable, ',')[0]).startOf('day').toDate(), moment(_.split(dateVariable, ',')[1]).endOf('day').toDate()]
            }
        } else if (condition == 'is') {
            PlatformApp.getDateFilter(dateVariable);
        } else if (condition == 'gt' || condition == 'lte') {
            let value = {};
            if (dateVariable === 'yesterday')
                value[condition] = moment().subtract(1, 'days').endOf('day').toDate();
            else if (dateVariable === 'thisweek')
                value[condition] = moment().endOf('week').toDate();
            else if (dateVariable === 'last7days')
                value[condition] = moment().endOf('day').toDate();
            else if (dateVariable === 'lastweek')
                value[condition] = moment().subtract(1, 'week').endOf('week').toDate();
            else if (dateVariable === 'nextweek')
                value[condition] = moment().add(1, 'week').endOf('week').toDate();
            else if (dateVariable === 'thismonth')
                value[condition] = moment().endOf('month').toDate();
            else if (dateVariable === 'lastmonth')
                value[condition] = moment().subtract(1, 'month').endOf('month').toDate();
            else if (dateVariable === 'nextmonth')
                value[condition] = moment().add(1, 'month').endOf('month').toDate();
            else
                value[condition] = moment().endOf('day').toDate();
            return value;
        } else if (condition == 'lt' || condition == 'gte') {
            let value = {};
            if (dateVariable === 'yesterday')
                value[condition] = moment().subtract(1, 'days').startOf('day').toDate();
            else if (dateVariable === 'thisweek')
                value[condition] = moment().startOf('week').toDate();
            else if (dateVariable === 'last7days')
                value[condition] = moment().startOf('day').toDate();
            else if (dateVariable === 'lastweek')
                value[condition] = moment().subtract(1, 'week').startOf('week').toDate();
            else if (dateVariable === 'nextweek')
                value[condition] = moment().add(1, 'week').startOf('week').toDate();
            else if (dateVariable === 'thismonth')
                value[condition] = moment().startOf('month').toDate();
            else if (dateVariable === 'lastmonth')
                value[condition] = moment().subtract(1, 'month').startOf('month').toDate();
            else if (dateVariable === 'nextmonth')
                value[condition] = moment().add(1, 'month').startOf('month').toDate();
            else
                value[condition] = moment().startOf('day').toDate();
            return value;
        }
    }

    static getDateFilter(dateVariable) {

        if (dateVariable === 'today')
            return {
                between: [moment().startOf('day').toDate(), moment().endOf('day').toDate()]
            }
        else if (dateVariable === 'yesterday')
            return {
                between: [moment().subtract(1, 'days').startOf('day').toDate(), moment().subtract(1, 'days').endOf('day').toDate()]
            }
        else if (dateVariable === 'thisweek')
            return {
                between: [moment().startOf('week').toDate(), moment().endOf('week').toDate()]
            }
        else if (dateVariable === 'last7days')
            return {
                between: [moment().subtract(7, 'days').startOf('day').toDate(), moment().endOf('day').toDate()]
            }
        else if (dateVariable === 'next30days')
            return {
                between: [moment().startOf('day').toDate(), moment().add(30, 'days').endOf('day').toDate()]
            }
        else if (dateVariable === 'lastweek')
            return {
                between: [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()]
            }
        else if (dateVariable === 'nextweek')
            return {
                between: [moment().add(1, 'week').startOf('week').toDate(), moment().add(1, 'week').endOf('week').toDate()]
            }
        else if (dateVariable === 'thismonth')
            return {
                between: [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
            }
        else if (dateVariable === 'lastmonth')
            return {
                between: [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
            }
        else if (dateVariable === 'nextmonth')
            return {
                between: [moment().add(1, 'month').startOf('month').toDate(), moment().add(1, 'month').endOf('month').toDate()]
            }
        else
            return null;
    }

    static getCondition(condition) {
        var conditions = {
            "contains": "like",
            "does not contain": "nlike",
            "is known": "",
            "is not known": "",
            "equals": "",
            "is between": "between",
            "is less than": "lte",
            "is greater than": "gte",
            "is": "is",
            "is after": "gt",
            "is before": "lt",
            "equals to": "",
            "not equals to": "neq",
            "is empty": "empty",
            "not empty": "not-empty"
        };
        return conditions[condition];
    }
}







// WEBPACK FOOTER //
// ./src/app/shared/services/app.service.ts